export type VisiblePage = number | "ellipsis";

const SIBLING_COUNT = 1;
const MAX_WITHOUT_ELLIPSIS = SIBLING_COUNT * 2 + 5;

function range(start: number, end: number): number[] {
  const pages: number[] = [];

  for (let page = start; page <= end; page += 1) {
    pages.push(page);
  }

  return pages;
}

export function getVisiblePages(currentPage: number, totalPages: number): VisiblePage[] {
  const safeTotal = Math.max(0, Math.floor(totalPages));

  if (safeTotal <= 1) {
    return safeTotal === 1 ? [1] : [];
  }

  const page = Math.min(Math.max(1, Math.floor(currentPage)), safeTotal);

  if (safeTotal <= MAX_WITHOUT_ELLIPSIS) {
    return range(1, safeTotal);
  }

  const leftSibling = Math.max(page - SIBLING_COUNT, 1);
  const rightSibling = Math.min(page + SIBLING_COUNT, safeTotal);
  const showLeftEllipsis = leftSibling > 2;
  const showRightEllipsis = rightSibling < safeTotal - 1;

  if (!showLeftEllipsis && showRightEllipsis) {
    const leftCount = 3 + SIBLING_COUNT * 2;
    return [...range(1, leftCount), "ellipsis", safeTotal];
  }

  if (showLeftEllipsis && !showRightEllipsis) {
    const rightCount = 3 + SIBLING_COUNT * 2;
    return [1, "ellipsis", ...range(safeTotal - rightCount + 1, safeTotal)];
  }

  return [1, "ellipsis", ...range(leftSibling, rightSibling), "ellipsis", safeTotal];
}
